import {NgModule} from '@angular/core';
import {AppIsGrantedDirective} from './app-is-granted.directive';

@NgModule({
	imports: [AppIsGrantedDirective],
	exports: [AppIsGrantedDirective],
})
export class SecurityModule {
}
